import { LoginInput } from "@finway-group/shared/lib/models"
// React imports
// Store imports
// Ant design imports
import { Button, Col, Form, Row, Spin } from "antd"
import { Store } from "antd/lib/form/interface"
import PasswordForm from "Components/forms/password.form"
import React, { useEffect, useState } from "react"
// Shared modules imports
// Other imports
import { useTranslation } from "react-i18next"
// Redux imports
import { useDispatch } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import { AuthService, NotificationService, UserService } from "Shared/services"
import { NotificationTypeEnum } from "Shared/services/notification.service"
import { ThunkDispatchResult } from "Shared/store"
import { resetPassword } from "Shared/store/actions/auth/authActions"
import useStateIfMounted from "Shared/utils/hooks/useStateIfMounted"
import AuthFooter from "./auth.footer"
import LoginLogo from "./login.logo"

interface IMatchParams {
    token: string
}

const ResetPasswordContainer: React.FC = () => {
    const dispatch: ThunkDispatchResult = useDispatch()
    const { token } = useParams<IMatchParams>()
    const history = useHistory()

    const [formInstance] = Form.useForm()

    const loggedInUser = UserService.getLoggedInUserProfile()

    const [isLoading, setIsLoading] = useStateIfMounted(false)
    const [hasLoaded, setHasLoaded] = useStateIfMounted(false)
    const [isValid, setIsValid] = useStateIfMounted(true)
    const { t } = useTranslation()

    useEffect(() => {
        ;(async () => {
            try {
                await AuthService.verifyToken(token)
                setIsValid(true)
                setHasLoaded(true)
            } catch (err) {
                setIsValid(false)
                setHasLoaded(true)
            }
        })()
    }, [])

    const handleSubmit = async ({ password }: Store) => {
        setIsLoading(true)
        if (loggedInUser) {
            try {
                const loginInput: LoginInput = {
                    email: loggedInUser.email,
                    password,
                }

                dispatch(resetPassword(token, loginInput))
                setIsLoading(true)
                NotificationService.send(NotificationTypeEnum.SUCCESS, t("notification:password_reset.title"), t("notification:password_reset.message"))

                history.push("/")
            } catch (err) {
                NotificationService.showErrorNotificationBasedOnResponseError(err, "Error")
            }
        }
    }

    return (
        <div className="login-bg flex flex-col items-center justify-center min-h-screen h-full w-full overflow-hidden relative">
            <Row className="w-full p-10 z-50 mb-30 my-auto">
                <Col span={24} className="max-w-400 min-w-300 my-0 mx-auto overflow-x-hidden overflow-y-hidden">
                    <LoginLogo />
                    <div className="bg-white w-full rounded-lg shadow p-32 mb-32 mt-32 md:mt-40">
                        {!hasLoaded ? (
                            <Spin spinning={true} />
                        ) : isValid ? (
                            <>
                                <PasswordForm formInstance={formInstance} onSubmit={handleSubmit} />
                                <Button size="large" className="w-full rounded-lg font-medium bg-login-button" type="primary" loading={isLoading} onClick={formInstance.submit}>
                                    {t("action:change_password")}
                                </Button>
                            </>
                        ) : (
                            <div>
                                <h2 className="p-0">{t("error:reset_password.title")}</h2>
                                <p className="mt-10">{t("error:reset_password.message")}</p>
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
            <Row className="w-full p-10 z-50 bottom-0 sticky mt-auto">
                <Col span={24} className="max-w-450 min-w-300 my-0 mx-auto">
                    <AuthFooter />
                </Col>
            </Row>
        </div>
    )
}

export default ResetPasswordContainer
